import { Role } from "@/models/role.model";
import { axiosInstance } from "./axiosInstance";

export const getRoles = async (): Promise<Role[]> => {
  try {
    const response = await axiosInstance.get<Role[]>("/api/role");
    return response.data;
  } catch (error) {
    console.error("Erro ao obter roles:", error);
    throw error;
  }
};
